import { LangEum } from '@/constant'
import { createContext } from 'react'
import { langMap } from './lang'

const context = createContext({
  currencyCode: 'HK$',
  lang: LangEum.en,
  isQuery: false,
  ...langMap.en,
})

export default context
